import _objectSpread from "/usr/app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _slicedToArray from "/usr/app/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import React from "react";
var __jsx = React.createElement;
import { useEffect, useState } from "react";
import stl from "./Sort.module.css";
import { CDN_LINK } from "@globalConfig";
import { isRangeFilter } from "@/pages/search/searchHooks/utils";
import { useTranslation } from "@i18n";
import ProgressiveImage from "@componentsShared/ProgressiveImage";
import useIsMobile from "@hooks/useIsMobile";
import useHelpers from "@hooks/useHelpers";
import { useLocation } from "react-router-dom";
var UnbxdSort = function UnbxdSort(_ref) {
  var className = _ref.className,
    sort = _ref.sort,
    selectedOptions = _ref.selectedOptions,
    sortOptions = _ref.sortOptions,
    filters = _ref.filters;
  var location = useLocation();
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var isMobile = useIsMobile();
  var _useHelpers = useHelpers(),
    navigateTo = _useHelpers.navigateTo;
  var _useState = useState([]),
    options = _useState[0],
    setOptions = _useState[1];
  var _useState2 = useState(false),
    showOptions = _useState2[0],
    setShowOptions = _useState2[1];
  var _useState3 = useState({}),
    selectedOption = _useState3[0],
    setSelectedOption = _useState3[1];
  var handleSortChange = function handleSortChange(option) {
    var _location$pathname;
    var newSort = (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.sort) === option.sort ? "" : option;
    setSelectedOption(newSort);
    var searchParams = new URLSearchParams(location.search);
    if (location !== null && location !== void 0 && (_location$pathname = location.pathname) !== null && _location$pathname !== void 0 && _location$pathname.includes('deal')) {
      var _location$pathname2;
      ((_location$pathname2 = location.pathname) === null || _location$pathname2 === void 0 ? void 0 : _location$pathname2.split('/deal/')[1]) && searchParams.set("deal_id", location.pathname.split('/deal/')[1]);
    }
    if (newSort.sort) {
      searchParams.set("sort", option === null || option === void 0 ? void 0 : option.sort);
      var mappedOptions = groupUnbxdFilters(selectedOptions);
      if (Object.values(mappedOptions).length) {
        Object.entries(mappedOptions).forEach(function (_ref2) {
          var _ref3 = _slicedToArray(_ref2, 2),
            key = _ref3[0],
            value = _ref3[1];
          searchParams.set(key, Array.isArray(value) ? value.join(",") : value);
        });
      }

      // On a /car-countries/:slug landing page the country filter comes from the
      // path (make_country_slug), not a selected chip, so groupUnbxdFilters emits
      // nothing for it and sorting would drop the country. Resolve the slug to its
      // numeric make_country id (mirrors UnbxdAsideFilters) so sort keeps the filter.
      if (location.pathname.includes("/car-countries/") && !searchParams.get("make_country")) {
        var _location$pathname$sp, _location$pathname$sp2;
        var slug = (_location$pathname$sp = location.pathname.split("/car-countries/")[1]) === null || _location$pathname$sp === void 0 ? void 0 : (_location$pathname$sp2 = _location$pathname$sp.split("/")[0]) === null || _location$pathname$sp2 === void 0 ? void 0 : _location$pathname$sp2.split("?")[0];
        if (slug) {
          var _makeCountryFacet$val;
          var makeCountryFacet = filters === null || filters === void 0 ? void 0 : filters.find(function (f) {
            return (f === null || f === void 0 ? void 0 : f.filterField) === "make_country";
          });
          var country = makeCountryFacet === null || makeCountryFacet === void 0 ? void 0 : (_makeCountryFacet$val = makeCountryFacet.values) === null || _makeCountryFacet$val === void 0 ? void 0 : _makeCountryFacet$val.find(function (v) {
            return v.slug === slug;
          });
          if (country) {
            searchParams.set("make_country", country.id);
          }
        }
      }
    } else {
      searchParams["delete"]("sort");
    }
    searchParams["delete"]("page");
    var newUrl = "?".concat(searchParams.toString());
    navigateTo("/filters".concat(newUrl));
  };
  useEffect(function () {
    var isNew = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.some(function (option) {
      return option.id == 1 && (option === null || option === void 0 ? void 0 : option.filterField) === "condition_id";
    });
    var isUsed = selectedOptions === null || selectedOptions === void 0 ? void 0 : selectedOptions.some(function (option) {
      return option.id == 0 && (option === null || option === void 0 ? void 0 : option.filterField) === "condition_id";
    });
    var defaultOptions = [{
      id: 2,
      text: t("discount", {
        ns: "web_search"
      }),
      sort: "-discount"
    }, {
      id: 3,
      text: t("lowest_price", {
        ns: "web_search"
      }),
      sort: "sellingprice"
    }, {
      id: 4,
      text: t("highest_price", {
        ns: "web_search"
      }),
      sort: "-sellingprice"
    }, {
      id: 5,
      text: t("lowest_mileage", {
        ns: "web_search"
      }),
      sort: "odometer"
    }, {
      id: 6,
      text: t("highest_mileage", {
        ns: "web_search"
      }),
      sort: "-odometer"
    }, {
      id: 7,
      text: t("recently_added", {
        ns: "web_search"
      }),
      sort: "-first_active_date"
    }];
    var apiOptions = Array.isArray(sortOptions) ? sortOptions.filter(function (opt) {
      return (opt === null || opt === void 0 ? void 0 : opt.name) && (opt === null || opt === void 0 ? void 0 : opt.value);
    }).map(function (opt, idx) {
      return {
        id: idx + 1,
        text: opt.name,
        sort: opt.value,
        is_selected: opt.is_selected
      };
    }) : [];
    var baseOptions = apiOptions.length ? apiOptions : defaultOptions;
    if (isNew && !isUsed) {
      // setSelectedOption({});
      setOptions(baseOptions.filter(function (option) {
        return option.sort !== "odometer" && option.sort !== "-odometer";
      }));
    } else {
      setOptions(baseOptions);
    }
  }, [selectedOptions, sortOptions]);
  useEffect(function () {
    // if (!sort) return;
    if (!sort) {
      setSelectedOption({});
      return;
    }
    var preSelectedOption = options.find(function (option) {
      return option.sort === sort;
    });
    setSelectedOption(preSelectedOption || {});
  }, [sort, options]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    role: "button",
    tabIndex: 0,
    id: "filter-sort-btn",
    className: [stl.sortFilterSp, className ? className : undefined, stl.wrapper, isMobile ? stl.isMobile : undefined].join(" "),
    onClick: function onClick() {
      return setShowOptions(function (pre) {
        return !pre;
      });
    },
    onKeyDown: function onKeyDown(e) {
      if (e.key === "Enter" || e.key === " ") {
        e.preventDefault();
        setShowOptions(function (pre) {
          return !pre;
        });
      }
    },
    "aria-expanded": showOptions,
    "aria-haspopup": "listbox"
  }, /*#__PURE__*/React.createElement(ProgressiveImage, {
    loading: "eager",
    className: "m-show",
    src: CDN_LINK + "/assets/images/sort-icon-mobile.svg",
    alt: "sort",
    "aria-label": "sort",
    width: 14,
    height: 12
  }), !Object.keys(selectedOption).length && /*#__PURE__*/React.createElement("strong", null, t("sort", {
    ns: "web_search"
  })), /*#__PURE__*/React.createElement("strong", null, selectedOption.text), showOptions && /*#__PURE__*/React.createElement("ul", {
    id: "filter-sort-dropdown",
    role: "listbox"
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.clsSortSel,
    onClick: function onClick() {}
  }, /*#__PURE__*/React.createElement("span", null), /*#__PURE__*/React.createElement("img", {
    src: CDN_LINK + "/assets/images/clsSortMenu.svg",
    alt: "Close sort menu icon"
  }), /*#__PURE__*/React.createElement("strong", {
    className: "m-show"
  }, t("sort", {
    ns: "web_search"
  }))), options.map(function (option, i) {
    return /*#__PURE__*/React.createElement("li", {
      id: "filter-sort-option-".concat(option.id),
      key: i,
      role: "option",
      "aria-selected": (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.sort) === option.sort,
      className: [stl.radioshapedDl, (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.sort) === option.sort ? stl.active : ""].join(" "),
      onClick: function onClick() {
        return handleSortChange(option);
      }
    }, /*#__PURE__*/React.createElement("input", {
      id: option.text,
      type: "radio",
      name: "sort-options",
      checked: (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.sort) === option.sort,
      readOnly: true
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: option.text
    }, t(option.text, {
      ns: "web_search"
    })), (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.sort) === option.sort ? /*#__PURE__*/React.createElement(ProgressiveImage, {
      waitUntilInteractive: true,
      src: CDN_LINK + "/assets/images/check-mark.svg",
      width: 24,
      height: 24,
      alt: "check-mark"
    }) : /*#__PURE__*/React.createElement("span", {
      className: stl.emptyCir
    }));
  }))));
};
export default UnbxdSort;
function groupUnbxdFilters(filters) {
  if (!filters) return;
  var noneRangeFilters = filters.filter(function (filter) {
    return !isRangeFilter(filter === null || filter === void 0 ? void 0 : filter.filterField);
  });
  var rangeFilters = filters.filter(function (filter) {
    return isRangeFilter(filter === null || filter === void 0 ? void 0 : filter.filterField);
  });
  var groupedRangeFilters = {};
  rangeFilters.forEach(function (filter) {
    groupedRangeFilters["".concat(filter === null || filter === void 0 ? void 0 : filter.filterField, "_from")] = filter.range_values.from;
    groupedRangeFilters["".concat(filter === null || filter === void 0 ? void 0 : filter.filterField, "_to")] = filter.range_values.to;
  });
  var groupedNoneRangeFilters = noneRangeFilters.reduce(function (acc, obj) {
    if (!acc[obj === null || obj === void 0 ? void 0 : obj.filterField]) {
      acc[obj === null || obj === void 0 ? void 0 : obj.filterField] = [];
    }
    acc[obj === null || obj === void 0 ? void 0 : obj.filterField].push(obj.id);
    return acc;
  }, {});
  return _objectSpread(_objectSpread({}, groupedNoneRangeFilters), groupedRangeFilters);
}